import { forwardRef } from 'react';
import { StyledListCell, StyledListCellButton } from './styled';

const ListCell = forwardRef((props, ref) => {
  const { isButton } = props;

  if (isButton) {
    return (
      <div style={{ display: 'table-cell', width: 'min-content' }}>
        <StyledListCellButton ref={ref} {...props} />
      </div>
    );
  } else {
    return <StyledListCell ref={ref} {...props} />;
  }
});

export default ListCell;
